<template>
  <div class="score-factor">
    <el-table
      v-if="tableRows.length"
      :data="tableRows"
      border
      style="width: 100%"
      :span-method="spanMethod"
    >
      <el-table-column prop="category" label="类别" align="left" width="160">
      </el-table-column>
      <el-table-column prop="title" label="评分指标" align="left" min-width="140">
      </el-table-column>
      <el-table-column label="得分" align="center" width="90">
        <template #default="{ row }">
          <span v-if="row.score === null || row.score === undefined">—</span>
          <span v-else>{{ row.score }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="comment" label="智能评价" align="left" min-width="220">
      </el-table-column>
      <el-table-column label="修改建议" align="left" min-width="220">
        <template #default="{ row }">
          <template v-if="row.suggestions && row.suggestions.length">
            <p
              v-for="(s, i) in row.suggestions"
              :key="i"
              class="suggestion-item"
            >
              {{ i + 1 }}. {{ s }}
            </p>
          </template>
          <span v-else class="no-suggestion">—</span>
        </template>
      </el-table-column>
    </el-table>
    <el-empty v-else description="暂无评分要素数据"></el-empty>
  </div>
</template>

<script>
export default {
  name: "ScoreFactor",
  props: {
    dimensionItems: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    // 按 category 分组并扁平化，便于 el-table 渲染；记录 category 跨行数
    tableRows() {
      const rows = [];
      const grouped = {};
      this.dimensionItems.forEach((item) => {
        const key = item.category || "其他";
        if (!grouped[key]) grouped[key] = [];
        grouped[key].push(item);
      });
      Object.keys(grouped).forEach((category) => {
        const children = grouped[category];
        children.forEach((child, idx) => {
          rows.push({
            category,
            title: child.title,
            score: child.score,
            comment: child.comment,
            suggestions: Array.isArray(child.suggestions) ? child.suggestions : [],
            _rowspan: idx === 0 ? children.length : 0,
          });
        });
      });
      return rows;
    },
  },
  methods: {
    spanMethod({ row, columnIndex }) {
      if (columnIndex === 0) {
        return {
          rowspan: row._rowspan,
          colspan: 1,
        };
      }
      return { rowspan: 1, colspan: 1 };
    },
  },
};
</script>

<style scoped lang="scss">
.score-factor {
  .suggestion-item {
    margin: 0;
    line-height: 22px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
  }
  .no-suggestion {
    color: #c0c4cc;
  }
}
</style>
